<template>
    <div class="auth">
        <div class="auth__content col-md-6">
            <div class="auth__content col-lg-6">
                <div class="content__inner">
                    <img alt="logo" class="logo" :src="require('@/assets/img/logo.svg')"/>
                    <amplify-sign-up v-bind:signUpConfig="signUpConfig"></amplify-sign-up>
                </div>
            </div>
        </div>
        <div class="auth__background col-lg-6"
             :style="{backgroundImage:
             'url(' + require(`@/assets/img/auth_background.svg`) + ')' }"></div>
    </div>
</template>

<script>
    import {createPasswordToggleIcon} from '../../_utils/createPasswordToggleIcon'

    export default {
        name: "Register",
        data() {
            return {
                signUpConfig: {
                    header: ' ',
                    hideDefaults: ['email, phone'],
                    defaultCountryCode: '1',
                    signUpFields: [
                        {
                            label: 'Email',
                            key: 'username',
                            required: true,
                            displayOrder: 1,
                            type: 'string',
                            signUpWith: true
                        },
                        {
                            label: 'Password',
                            key: 'password',
                            required: true,
                            displayOrder: 2,
                            type: 'password'
                        },
                    ]
                }
            }
        },
        mounted() {
            createPasswordToggleIcon()
        }
    }
</script>

<style scoped>

</style>
